interface EnvelopeType {
  openBack?: string;
}

interface LinerType {
  image?: string;
}

interface EnvelopeBottomBackProps {
  envelope?: EnvelopeType;
  liner?: LinerType;
  linerShading?: string;
}

export const EnvelopeBottomBack = ({envelope, liner, linerShading}: EnvelopeBottomBackProps) => (
  <div className="env-wrapper bottom-back env-final">
    <img className="env-group env-group__open-bottom" src={envelope?.openBack} alt="" />
    <img className="env-group env-group__bottom-liner" src={liner?.image} alt="" />
    <img className="env-group env-group__bottom-liner-shading" src={linerShading} alt="" />
  </div>
);
